import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { routes } from '../../routes';
import { createEnrollmentRequiredDocument } from '../../services/school/enrollmentRequiredDocument/createEnrollmentRequiredDocument';
import { CreateEnrollmentRequiredDocumentType } from '../../types/EnrollmentRequiredDocument';
import { CreateEnrollmentRequiredDocumentFormValidation } from './CreateEnrollmentRequiredDocumentFormValidation';
export default function CreateEnrollmentRequiredDocument() {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createEnrollmentRequiredDocument, mutationKey: 'createEnrollmentRequiredDocument' });
  const { control, handleSubmit, formState: { errors } } = useForm<CreateEnrollmentRequiredDocumentType>
    (
      {
        resolver: yupResolver(CreateEnrollmentRequiredDocumentFormValidation),
        defaultValues: {
          description: ''
        },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Tipo de documento criado");
        navigate(routes.enrollmentrequireddocuments);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.enrollmentrequireddocuments);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent control={control} errors={errors} label='Tipo de documento' name='description' style={{ display: "100%" }} required={true}/>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}